
import { Component, Vue } from 'vue-property-decorator'
import { apiAiUsageLists } from '@/api/setting'
import { RequestPaging } from '@/utils/util'
import LsPagination from '@/components/ls-pagination.vue'

@Component({
  components: { LsPagination }
})
export default class AiUsageLists extends Vue {
  pager = new RequestPaging()
  dateRange: string[] = []
  form: any = {
    shop_name: '',
    scene: '',
    status: '',
    start_time: '',
    end_time: ''
  }

  sceneText (scene: string) {
    const map: Record<string, string> = {
      sticker_generate: '贴图生成'
    }
    return map[scene] || scene
  }

  onDateChange (val: string[] | null) {
    if (val && val.length === 2) {
      this.form.start_time = val[0]
      this.form.end_time = val[1]
    } else {
      this.form.start_time = ''
      this.form.end_time = ''
    }
  }

  getList () {
    this.pager.request({
      callback: apiAiUsageLists,
      params: { ...this.form }
    })
  }

  onReset () {
    this.form = { shop_name: '', scene: '', status: '', start_time: '', end_time: '' }
    this.dateRange = []
    this.getList()
  }

  created () {
    this.getList()
  }
}
